import { Wizard } from "src/app/core/wizard/wizard";
import { StoreAddComponent } from "./store-add/store-add.component";
import { OnDestroy, Injectable } from "@angular/core";

// new-popup-wizard.ts
@Injectable({
  providedIn: 'root'
})
export class StoreAddWizard extends Wizard<any> implements OnDestroy {
  key = 'store-add';
  pageTypeMap = {
    'store-add': StoreAddComponent,
  };

  startingPageKey = 'store-add';

  constructor() {
    super();
    this.width = this.calculateResponsiveWidth();

    // Add resize event listener
    window.addEventListener('resize', () => {
      this.width = this.calculateResponsiveWidth();
    });
  }

  // Don't forget to clean up the event listener when the component is destroyed
  ngOnDestroy() {
    window.removeEventListener('resize', () => {
      this.width = this.calculateResponsiveWidth();
    });
  }

  private calculateResponsiveWidth(): number {
    const screenWidth = window.innerWidth;

    if (screenWidth < 768) { // Mobile
      return Math.min(screenWidth * 0.9, 400); // Smaller on mobile
    } else if (screenWidth < 1024) { // Tablet
      return Math.min(screenWidth * 0.7, 600); // More compact on tablet
    } else if (screenWidth < 1440) { // Laptop
      return 800; // Fixed width for laptop
    } else { // Large screens
      return Math.min(screenWidth * 0.5, 1000); // Larger max width, but smaller relative to screen
    }
  }
}
